import moment from "moment"

export default function formatDate(date) {
  return moment(date).format("DD.MM.YYYY")
}

export const createdAtDate = date => {
  return moment(date).format("D. MMMM YYYY")
}
